export default ({ language, country }) => {
  window.location.replace(
    `/switchLanguage/${language.value}/${country.value}?redirectBack=${encodeURIComponent(
      window.location.href,
    )}`,
  );
};
